import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { useAppSelector } from "hooks/useAppSelector";
import MainFlow from "./MainFlow";
import AccountSetup from "screens/AccountSetup/AccountSetup";
import SelectTenant from "screens/SelectTenant/SelectTenant";
import Logout from "screens/Logout/Logout";
import { AuthenticatedFlowStackParamList } from "./types";

const AuthenticatedFlowStack =
  createNativeStackNavigator<AuthenticatedFlowStackParamList>();

const AuthenticatedFlow = () => {
  const { tenantSubdomain } = useAppSelector((state) => state.tenant);
  // console.log("Logged in flow:", tenantSubdomain);

  return (
    <AuthenticatedFlowStack.Navigator screenOptions={{ headerShown: false }}>
      {tenantSubdomain !== null ? (
        <>
          <AuthenticatedFlowStack.Screen
            name="MainFlow"
            component={MainFlow}
            options={{
              animation: "slide_from_bottom",
              title: "Welcome",
            }}
          ></AuthenticatedFlowStack.Screen>
          <AuthenticatedFlowStack.Screen
            name="AccountSetup"
            component={AccountSetup}
            options={{ title: "Finish account setup" }}
          ></AuthenticatedFlowStack.Screen>
        </>
      ) : (
        <AuthenticatedFlowStack.Screen
          name="SelectTenant"
          component={SelectTenant}
        ></AuthenticatedFlowStack.Screen>
      )}
      <AuthenticatedFlowStack.Screen
        name="LogOut"
        component={Logout}
      ></AuthenticatedFlowStack.Screen>
    </AuthenticatedFlowStack.Navigator>
  );
};

export default AuthenticatedFlow;
